<template>
    <v-dialog
        :value="visible"
        :max-width="maxWidth"
        :persistent="persistent"
    >
        <v-card>
            <v-card-title :class="`headline ${titleColor} white--text`">
                <v-layout row wrap align-start>
                    <v-flex
                        xs11
                        text-xs-left
                    >
                        <slot name="title" />
                    </v-flex>
                    <v-spacer />
                    <v-btn icon dark class="ma-0" @click.native="closeDialog">
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <slot name="content" />
            </v-card-text>
            <v-card-actions>
                <slot name="actions" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'base-dialog',
    props: {
        visible: { type: Boolean, required: false, default: false },
        titleColor: { type: String, required: false, default: 'primary' },
        maxWidth: { type: String, required: false, default: '600px' },
        persistent: { type: Boolean, required: false, default: false },
    },
    methods: {
        closeDialog() {
            this.$emit('close');
        },
    },
};
</script>
